import React from 'react';
import styled from 'styled-components';
import davidoff from '../../../../../../themes/davidoff';

export default styled.span`
  color: ${davidoff.colors.brown};
`;
